export const blockServices = {
  protocol: "procotol",
  iptype_single: "iptype_thisip",
  iptype_range: "iptype_iprange",
  iptype_all: "iptype_allip",
  single_ip_prefix: "single_ipaddress",
  range_start_prefix: "range_start_ipaddress",
  range_end_prefix: "range_end_ipaddress",
};

export default blockServices;
